import React from 'react';
import './cardRates.scss'; // Asegúrate de tener este archivo o reemplázalo con styled-components si prefieres.
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';


interface ICardRatesProps {
    tituloBanner: string;
    imagenPrincipal: any[];
    descripcion: any;
    tituloDescripcion: string;
    tituloBoton: string;
    redireccionBoton: string;
}

const CardRates = (props:ICardRatesProps) => {

    const [title, price, note] = props.tituloBanner.split("|");
    
    return (
        <div className="m-card-rates">
        <h3 className="m-card-rates__title">{title}</h3>
        <p className="m-card-rates__price">{price}</p>
        <p className="m-card-rates__note">{note}</p>
        <p className="m-card-rates__description">
            {props.tituloDescripcion}
        </p>

        <a className="m-card-rates__button" href={props.redireccionBoton}>{props.tituloBoton}</a>
        <hr style={{ border: 'none', height: '1px', borderTop: '1px solid #888', marginBottom: '24px' }} />
        <ul className="m-card-rates__features">
            <li className="m-card-rates__feature m-card-rates__feature--available">
                {contentfulRenderOptions(props.descripcion.json, undefined, props.imagenPrincipal)}
            </li>
        </ul>
        </div>
    );
};

export default CardRates;
